// Vendors
import React, { useState } from 'react'

// Components
import { FieldNumber } from 'components/FieldNumber'
import { FormFieldEditerFieldType } from 'components/FormFieldEditerFieldType'
import { FormFieldEditerFieldPreview } from 'components/FormFieldEditerFieldPreview'
import {
  FormFieldEditer,
  FormFieldEditerProps,
} from 'components/FormFieldEditer'

// Styles

// Interfaces
export type FormFieldEditerNumberProps = {
  index: number
  id: string
}

export const FormFieldEditerNumber = (
  props: FormFieldEditerProps
): JSX.Element => {
  /*
  |-----------------------------------------------------------------------------
  | Constants
  |-----------------------------------------------------------------------------
  |
  |
  */

  /*
  |-----------------------------------------------------------------------------
  | States
  |-----------------------------------------------------------------------------
  |
  |
  */

  const [fieldName, setFieldName] = useState(props.question.label)

  /*
  |-----------------------------------------------------------------------------
  | Functions
  |-----------------------------------------------------------------------------
  |
  |
  */

  /*
  |-----------------------------------------------------------------------------
  | Renders
  |-----------------------------------------------------------------------------
  |
  |
  */
  return (
    <FormFieldEditer {...props}>
      <FormFieldEditerFieldType
        index={props.index}
        handleQuestion={props.handleQuestion}
        fieldTypeLabel="NUMÉRICO"
        fieldName={{ get: fieldName, set: setFieldName }}
      />

      <FormFieldEditerFieldPreview>
        <FieldNumber
          name={`number-${props.index}`}
          label={fieldName !== '' ? fieldName : 'Nome do campo'}
        />
      </FormFieldEditerFieldPreview>
    </FormFieldEditer>
  )
}
